import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Hero from '../../component/Hero';

const DetailHome = () => {
  const [dataLowongan, setDataLowongan] = useState([]);

  let { slug } = useParams();

  useEffect(() => {
    if (slug !== undefined) {
      axios
        .get(`https://dev-example.sanbercloud.com/api/job-vacancy/${slug}`)
        .then((res) => {
          let result = res.data;
          setDataLowongan({ ...result });
          console.log(result);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  console.log(dataLowongan);

  return (
    <>
      <div className="container-home">
        <Hero />
        <div className="container-home_content">
          <div className="container-home_content-list">
            <>
              <br />
              <Link to={`/job-vacancy/${dataLowongan.id}`}>
                <div className="flex flex-col justify-start gap-4 p-4 bg-white shadow-xl max-h-44 rounded-xl dark:bg-gray-800 md:flex-row">
                  <div className="relative">
                    <img
                      src={dataLowongan.company_image_url}
                      width={150}
                      height={150}
                      alt="company imageurl"
                    />
                    <span className="absolute px-2 py-1 text-xs text-white bg-gray-700 bg-opacity-50 rounded right-2 bottom-2">
                      7 min
                    </span>
                  </div>
                  <div className="flex flex-col justify-between">
                    <div className="flex items-start justify-between my-2 text-gray-700 dark:text-white md:m-0">
                      <p className="text-xl leading-5">{dataLowongan.title}</p>
                    </div>
                    <div className="flex items-center my-2 text-xs text-gray-500 dark:text-gray-400 md:m-0">
                      {dataLowongan.job_status === 1
                        ? 'Lowongan dibuka'
                        : 'Lowongan Ditutup'}
                    </div>
                    <div className="flex items-center my-2 text-xs text-gray-500 dark:text-gray-400 md:m-0">
                      <h5>
                        Minimal Gaji {dataLowongan.salary_min} -{' '}
                        {dataLowongan.salary_max}
                      </h5>
                    </div>
                    <div className="flex items-start my-2 md:m-0">
                      <div className="flex flex-col items-start justify-center ml-2">
                        <span className="flex items-center text-sm text-gray-600 dark:text-gray-200">
                          {dataLowongan.company_name}
                          <span className="block w-2 h-2 ml-1 bg-green-500 rounded-full"></span>
                        </span>
                        <span className="text-xs text-gray-400">
                          {dataLowongan.company_city}, {dataLowongan.job_tenure}{' '}
                          : {dataLowongan.job_type}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailHome;
